import { Component, Input, OnInit, Self } from '@angular/core';
import { ConfigQuestion } from '../../models/config-question.interface';
import {
	ControlValueAccessor,
	UntypedFormArray,
	UntypedFormControl,
	UntypedFormGroup,
	NgControl,
} from '@angular/forms';
import { ErrorMessage } from '../../constants/enum.const';

@Component({
	selector: 'bcb-generic-input',
	templateUrl: './generic-input.component.html',
	styleUrls: ['./generic-input.component.scss'],
})
export class GenericInputComponent implements ControlValueAccessor, OnInit {
	@Input() question!: ConfigQuestion;
	@Input() errorMessage?: ErrorMessage;
	prefixIcon?: string;
	suffixIcon?: string;
	hint?: { horizontalPosition: 'start' | 'end'; value: string };
	transform?: 'uppercase';

	control!: UntypedFormControl;
	parent!: UntypedFormGroup | UntypedFormArray | null;
	disabled!: boolean;

	constructor(@Self() private readonly controlDirective: NgControl) {
		controlDirective.valueAccessor = this;
	}

	onChange: (value: any) => void = () => {};

	onTouched: () => void = () => {};

	ngOnInit(): void {
		this.control = this.controlDirective.control as UntypedFormControl;
		this.parent = this.control.parent;

		this.prefixIcon = this.question.attributes?.prefixIcon;
		this.suffixIcon = this.question.attributes?.suffixIcon;
		this.hint = this.question.attributes?.hint;
		this.transform = this.question.attributes?.transform;
	}

	onInput(target: HTMLInputElement): void {
		const value = target.value;
		const transformed =
			this.transform === 'uppercase' ? value.toUpperCase() : value;

		if (transformed !== value) {
			// Rewriting the value drops the caret at the end of the field, so where
			// the client was typing has to be restored afterwards.
			const { selectionStart, selectionEnd } = target;
			this.control.setValue(transformed, { emitEvent: false });
			if (selectionStart !== null && selectionEnd !== null) {
				target.setSelectionRange(selectionStart, selectionEnd);
			}
		}

		this.onChange(transformed);
	}

	// The template binds this same control instance, so Angular already keeps the
	// view in sync. Writing back into the control here re-enters writeValue.
	writeValue(_value: any): void {}

	registerOnChange(onChange: (value: any) => void): void {
		this.onChange = onChange;
	}

	registerOnTouched(onTouched: () => void): void {
		this.onTouched = onTouched;
	}

	setDisabledState(disabled: boolean): void {
		this.disabled = disabled;
	}
}
